import CallsToAciton from '@components/calls-to-action/calls-to-action.view';
import ComponentRenderer from '@components/cms-components/component-renderer/component-renderer.view';
import Img from '@components/img';
import TextBlock from '@components/text-block';
import TwoColumn from '@components/two-column';
import { Yeseva } from 'app/fonts';
import type { ReactElement } from 'react';
import React from 'react';
import type { StylistListData } from 'types/components/stylist-list';
import type { DataProps } from 'types/props/data-props';
import type { Stylist } from 'types/stylist';
import mapLevelToLabel from 'utils/map-level-to-label';
import mapRoleToLabel from 'utils/map-role-to-label';
import { validateString } from 'utils/validate-string';

import styles from './stylist-list.module.scss';

const EMPTY: Stylist[] = [];

const EVEN = 2;
const ZERO = 0;

const stylistsClass = validateString(styles.stylists);
const stylistClass = validateString(styles.stylist);

function StylistListComponent({
  context,
  description,
  eyebrow,
  heading,
  subHeading,
  stylists = EMPTY,
}: Readonly<DataProps<StylistListData>>): ReactElement {
  return (
    <div>
      <TextBlock
        description={
          <ComponentRenderer context={context}>{description}</ComponentRenderer>
        }
        eyebrow={eyebrow}
        heading={<h2 className={Yeseva.className}>{heading}</h2>}
        layout="center"
        size="medium"
        subHeading={subHeading}
      />

      <ul className={stylistsClass}>
        {stylists.map((stylist, index) => {
          const levelRole =
            stylist.role === 'stylist'
              ? mapLevelToLabel(stylist.level)
              : `${mapLevelToLabel(stylist.level)} / ${mapRoleToLabel(
                  stylist.role,
                )}`;
          return (
            <li className={stylistClass} key={stylist.name}>
              <TwoColumn
                callsToAction={
                  <CallsToAciton
                    secondaryCta={{
                      label: 'View prices',
                      url: stylist.slug,
                    }}
                  />
                }
                description={<p>{stylist.bio}</p>}
                heading={<h3 className={Yeseva.className}>{stylist.name}</h3>}
                layout={index % EVEN === ZERO ? 'left' : 'right'}
                media={
                  <Img
                    alt={stylist.name}
                    effect={index % EVEN === ZERO ? 'color' : 'box-right'}
                    imageSource={stylist.image}
                    sizes="(max-width: 768px) 100vw, 50vw"
                  />
                }
                size="small"
                subHeading={<span>{levelRole}</span>}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default StylistListComponent;
